import { render, staticRenderFns } from "./Edit_project.vue?vue&type=template&id=21b8971c&scoped=true&"
import script from "./Edit_project.vue?vue&type=script&lang=js&"
export * from "./Edit_project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8971c",
  null
  
)

export default component.exports